import styled from "styled-components";
import { SdfButton } from "@waypoint/react-components";
import { colors, breakpoints } from "@headless-shell/shared-styles";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.white.default};
  padding-top: 2rem;

  #my-apps-root {
    width: 100%;
    max-width: 90rem;
    margin-inline: auto;
  }

  #enterprise-search-root {
    background: white;
    #compare-app-box,
    #compare-app-title-box {
      padding: 1rem;
    }
    &.nonLoggedSearch {
      padding-top: 5rem;
    }
    &.loggedSearch {
      padding-top: 2rem;
    }

    &.enterprise-search-container {
    width: 100%;
    max-width: 96rem;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    padding-left: 1rem;
    padding-right: 1rem;

    @media (min-width: ${breakpoints.lg}) {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
}
`;
export const AppContent = styled.div`
  margin-top: 0;
  transition: margin-top 0.3s ease;

  @media (max-width: ${breakpoints.md}) {
    margin-top: ${({ $searchOpen }) => ($searchOpen ? '3rem' : '0rem')};
  }
`;

export const LoadingState = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 140px);
`;

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem;
`;

export const LoadingText = styled.div`
  color: ${colors.gray.text};
  font-size: 1.1rem;
  font-weight: 500;
`;

export const ErrorState = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 140px);
  padding: 2rem;
`;

export const ErrorContent = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.red.light};
`;

export const ErrorTitle = styled.h2`
  color: ${colors.red.primary};
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
`;

export const ErrorMessage = styled.p`
  color: ${colors.gray.text};
  font-size: 1rem;
  margin: 0 0 2rem 0;
  line-height: 1.5;
`;

export const StyledReloadButton = styled(SdfButton)`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }
`;

export const MainContainer = styled.main`
  flex: 1;
  min-height: calc(100vh - 140px);
  width: 100%;
  position: relative;
`;

// Fallback App Styles
export const FallbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 2rem;
`;

export const FallbackCard = styled.div`
  text-align: center;
  max-width: 500px;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid ${colors.red.light};
`;

export const FallbackIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1.5rem;
`;

export const FallbackTitle = styled.h2`
  color: ${colors.red.primary};
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
`;

export const FallbackMessage = styled.p`
  color: ${colors.gray.text};
  font-size: 1rem;
  margin: 0 0 2rem 0;
  line-height: 1.5;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

export const FallbackActions = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StyledFallbackButton = styled(SdfButton)`
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }

  &[variant="primary"]:hover {
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  }

  &[variant="secondary"]:hover {
    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
  }

  &[variant="outline"]:hover {
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const NavigationLinks = styled.nav`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 2rem;
`;

export const NavLink = styled.a`
  padding: 0.75rem 1.5rem;
  background: ${colors.blue.primary};
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-block;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
    background: ${colors.blue.secondary};
    color: white;
    text-decoration: none;
  }

  &.secondary {
    background: ${colors.green.primary};

    &:hover {
      background: ${colors.green.secondary};
      box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
    }
  }
`;

